import { default as windowStore } from "../store";
import { WindowWrapper } from "../types";

export function getWindowsByTabGroupId(windowId: string, tabGroupId: string): WindowWrapper[] {
    const windows = windowStore.list;
    return Object.keys(windows).reduce<WindowWrapper[]>((memo, id) => {
        const win = windows[id];
        if (win.API.tabGroupId === tabGroupId && win.API.id !== windowId) {
            memo.push(win);
        }
        return memo;
    }, []);
}

export function isEmpty(object: any): boolean {
    if (!object || Object.keys(object).every((value) => object[value] === undefined)) {
        return true;
    }
    return false;
}
